import React from 'react';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Typography, ThemeProvider, createTheme } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import "../assets/style.css";
import { styled } from '@mui/material/styles';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 'none',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
    '& .Mui-expanded': {

        borderRadius: '17px 17px 0px 0px',
    },
    marginBottom: '24px',
    backgroundColor: 'transparent'
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? '#13161D'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    height: '65px',
    borderRadius: '17px',

    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },

    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    paddingTop:'0px',
    borderTop: 'none',
    backgroundColor: '#13161D',
    borderRadius: '0px 0px 17px 17px',
}));

const BlogsDetailsFAQ = ({ faqs }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const theme = createTheme({
        palette: {
            mode: 'dark',
        },
    });
    return (
        <>
            <hr className="dividerSoft" />
            <h4 className='fw-bold'>FAQs</h4>
            <div className="faq-second-section mt-3">
                <div className="">
                    <ThemeProvider theme={theme}>
                        {faqs && faqs.length > 0 && faqs.map((row, i) => {
                            return (
                                <Accordion expanded={expanded === `panel${i}`} onChange={handleChange(`panel${i}`)} >
                                    <AccordionSummary className={`${expanded === `panel${i}` ? 'text-warning' : ''}`} aria-controls={`panel${i}d-content`} id={`panel1d-header`}>
                                        {row?.question}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            {row?.answer}

                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )

                        })
                        }
                    </ThemeProvider>
                </div>
            </div>
        </>
    );
};

export default BlogsDetailsFAQ;